import mitt from 'mitt'

export default defineNuxtPlugin(async (nuxtApp) => {
    const emitter = mitt<{
        spot_rates_updated: Record<string, any>
    }>()

    const { token } = await $fetch<{ token: string }>('/ws-token')

    const ws = new WebSocket(`wss://${location.host}/_ws`, token)

    ws.onmessage = (evt) => {
        try {
            const msg = JSON.parse(evt.data)
            if (msg.event && msg.data) {
                emitter.emit(msg.event, msg.data)
            }
        } catch (e) {

        }
    }

    nuxtApp.provide('socket', emitter)
})
